import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    q: "¿Que incluye cada vela Serena?",
    a: "Cada vela incluye cera de soja premium, una fragancia artesanal y un codigo QR unico que desbloquea tu ritual digital personalizado en la app.",
  },
  {
    q: "¿Como funciona la experiencia phygital?",
    a: "Al escanear el codigo QR de tu vela con la camara de tu telefono, se abre automaticamente tu ritual digital con afirmaciones, temporizador y audio ambiental adaptado al aroma de tu vela.",
  },
  {
    q: "¿El modulo de bienestar tiene costo?",
    a: "No. El modulo de bienestar es 100% gratuito. Creemos que el bienestar debe ser accesible para todas las personas que elijan Serena.",
  },
  {
    q: "¿Cuanto dura cada vela?",
    a: "Dependiendo de la coleccion, entre 45 y 65 horas de combustion limpia. Cada vela esta diseñada para acompanarte durante semanas.",
  },
  {
    q: "¿A donde hacen envios?",
    a: "En el lanzamiento del MVP, realizamos envios a toda la Republica Mexicana. Pronto expandiremos a mas mercados.",
  },
  {
    q: "¿Que metodos de pago aceptan?",
    a: "Aceptamos tarjetas de credito y debito a traves de Stripe. En proximas fases agregaremos metodos locales como OXXO y SPEI.",
  },
  {
    q: "¿Necesito la app para usar la vela?",
    a: "La vela funciona perfectamente sola. La app y el ritual digital son una capa extra de bienestar que enriquece tu experiencia, pero no es obligatoria.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export default function FAQSection() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
          className="text-center mb-16"
        >
          <motion.p variants={fadeUp} className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80 mb-4">
            Preguntas Frecuentes
          </motion.p>
          <motion.h2
            variants={fadeUp}
            className="font-serif text-4xl md:text-5xl font-normal tracking-tight leading-tight text-white"
            data-testid="faq-heading"
          >
            Resolvemos tus
            <span className="italic text-[#D4AF37]"> dudas</span>
          </motion.h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-sm md:text-base font-medium text-white/80 hover:text-[#D4AF37] hover:no-underline py-6 transition-colors duration-300">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-white/40 leading-relaxed pb-6">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
